<template>

            <!----------- images ---------------------------------->
            <div class="column is-12">
              <div class="box">
                <div class="columns">
                  <div class="column is-12">
                    <strong>{{ elLabel }}</strong>

                    <!-- only one pic for thumbnails -->
                    <a v-if="!(propName == 'thumbnail') || ((propName == 'thumbnail') && (n.length < 1))" class="icon is-info is-large is-pulled-right" @click="$emit('showImageSelector', propName)">
                      <i class="fa fa-plus-circle fa-2x"></i>
                    </a>

                  </div>
                </div>
                
                  <draggable v-model="n" :options="{draggable:'.column', handle:'.my-handle'}" class="columns is-multiline">
                  <div class="column is-3" v-for="(i, index) in n" :key="index">

                    <div class="card card-equal-height">
                                        <header class="card-header">
                <a class="is-pulled-right icon my-handle">
                  <i class="fa fa-arrows"></i>
                </a>
            </header>
                      <div class="card-image">
                        <figure class="image">
                          <img :src="assetsBaseUrl + i.path">
                        </figure>
                      </div>
                      <div class="card-content">
                        <div class="content">
                          <textarea rows="4" class="textarea" v-model="i.caption" placeholder="Bildtext"></textarea>
                          <p><input type="text" class="input" placeholder="Fotonachweis" v-model="i.credits"></p>
                        </div>
                      </div>
                      <footer class="card-footer">
                        <a class="card-footer-item" @click="$emit('imageWasDeleted', { prop: propName, i: index } )">Löschen</a>
                      </footer>
                    </div>

                  </div>
                  </draggable>

                
              </div>
            </div>

</template>

<script>
import draggable from 'vuedraggable'
export default {
  inject: ['$validator'],
  props: ['data', 'elLabel', 'propName'],
  data () {
    return {
    }
  },
  methods: {
  },
  components: {
    draggable
  },
  computed: {
    n: {
      get () {
        return this.data
      },
      set (value) {
        this.$emit('wasSorted', value)
      }
    },
    assetsBaseUrl () {
      return this.$store.getters.assetsBaseUrl
    }
  }
}
</script>

<style scoped>
.card-content {padding:0;}
</style>


// WEBPACK FOOTER //
// src/components/cms/elements/Images.vue